import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-01296f04"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "index-box" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"padding-bottom":"16px"} }, "请选择导出格式", -1))
const _hoisted_3 = { style: {"padding":"16px 0"} }
const _hoisted_4 = { class: "form-btn-group" }

import ScPage from '@/components/common/page/ScPage.vue';
import ScBtn from '@/components/common/widget/ScBtn.vue';
import { inject, ref } from 'vue';
import { WindowTool } from '@/components/common/window/WindowInterface';


export default /*#__PURE__*/_defineComponent({
  __name: 'ExportForm',
  setup(__props) {

const windowTool = inject<WindowTool | false>(WindowTool, false);
const value = ref(0);
const formats = [
  'ip:端口 账号 密码',
  'ip|端口|账号|密码|到期日期',
  'ip/端口/账号/密码',
  'ip/端口/账号/密码/地区',
];

async function onSubmit() {
  if (windowTool) {
    windowTool.close(value.value);
  }
}

function onCancel() {
  if (windowTool) {
    windowTool.close(false);
  }
}

return (_ctx: any,_cache: any) => {
  const _component_a_radio_button = _resolveComponent("a-radio-button")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!

  return (_openBlock(), _createBlock(ScPage, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(_component_a_radio_group, {
          value: value.value,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event)),
          "button-style": "solid"
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(formats, (_, key) => {
              return _createVNode(_component_a_radio_button, {
                key: key,
                value: key
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 格式" + _toDisplayString(key + 1), 1)
                ]),
                _: 2
              }, 1032, ["value"])
            }), 64))
          ]),
          _: 1
        }, 8, ["value"]),
        _createElementVNode("div", _hoisted_3, "导出格式为: " + _toDisplayString(formats[value.value]), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(ScBtn, {
          handler: onSubmit,
          text: "确定",
          type: "primary"
        }),
        _createVNode(ScBtn, {
          handler: onCancel,
          style: {"margin-left":"10px"},
          text: "取消"
        })
      ])
    ]),
    _: 1
  }))
}
}

})